import { apiClient } from './apiClient'
import type {
  PointSystemDTO,
  CreatePointSystemRequest,
  UpdatePointSystemRequest
} from '../types/dtos'

class PointSystemService {
  private readonly basePath = '/ranking/point-systems'

  /**
   * Get all point systems (system defaults + tenant-specific)
   */
  async getPointSystems(): Promise<PointSystemDTO[]> {
    const response = await apiClient.get<PointSystemDTO[]>(this.basePath)
    return response.data
  }

  /**
   * Get point system by ID
   */
  async getPointSystemById(id: number): Promise<PointSystemDTO> {
    const response = await apiClient.get<PointSystemDTO>(`${this.basePath}/${id}`)
    return response.data
  }

  /**
   * Create new point system
   */
  async createPointSystem(request: CreatePointSystemRequest): Promise<PointSystemDTO> {
    const response = await apiClient.post<PointSystemDTO>(this.basePath, request)
    return response.data
  }

  /**
   * Update existing point system
   */
  async updatePointSystem(id: number, request: UpdatePointSystemRequest): Promise<PointSystemDTO> {
    const response = await apiClient.put<PointSystemDTO>(`${this.basePath}/${id}`, request)
    return response.data
  }

  /**
   * Delete point system (soft delete)
   */
  async deletePointSystem(id: number): Promise<void> {
    await apiClient.delete(`${this.basePath}/${id}`)
  }
}

export const pointSystemService = new PointSystemService()
